export default "__VITE_ASSET__EiSW4ALv__"